// Dependencies
import React, { FC, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
// Core & Lab
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
// Actions
import { updateStocksEditMode } from './redux/reducer';
// Types
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Popover, Tooltip } from '@mui/material';
import { AppState } from '../../reducers';

const ChannelManagerStockEditOptions: FC = (): ReactElement | null => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const stocks_edit_mode = useSelector((state: AppState) => state.channelManager.stocks_edit_mode);
    const onUpdateEditMode = (mode: null | 'STOCK' | 'ROOM_BLACK_OUTS') => () => {
        dispatch(updateStocksEditMode(mode));
    };
    const [black_out_helper_anchorEl, setBlackoutHelperAnchorEl] = React.useState<HTMLButtonElement | null>(null);

    const handleClickBlackoutHelper = (event: React.MouseEvent<HTMLButtonElement>) => {
        setBlackoutHelperAnchorEl(event.currentTarget);
    };
    const handleCloseBlackoutHelper = () => {
        setBlackoutHelperAnchorEl(null);
    };
    const open_black_out_helper = Boolean(black_out_helper_anchorEl);
    const id_black_out_helper = open_black_out_helper ? 'simple-popover' : undefined;

    const [stock_helper_anchorEl, setStockHelperAnchorEl] = React.useState<HTMLButtonElement | null>(null);

    const handleClickStockHelper = (event: React.MouseEvent<HTMLButtonElement>) => {
        setStockHelperAnchorEl(event.currentTarget);
    };
    const handleCloseStockHelper = () => {
        setStockHelperAnchorEl(null);
    };
    const open_stock_helper = Boolean(stock_helper_anchorEl);
    const id_stock_helper = open_stock_helper ? 'simple-popover' : undefined;
    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', justifyContent:'flex-start' }}>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <FormControl>
                    <FormControlLabel control={<Checkbox checked={stocks_edit_mode === 'ROOM_BLACK_OUTS'} onChange={onUpdateEditMode('ROOM_BLACK_OUTS')} color={'primary'} />} sx={{ whiteSpace: 'nowrap' }} label={t('shared.activate-edit-black-outs')} />
                </FormControl>
                <Tooltip title={t('shared.info')}><button style={{ border: 'none', backgroundColor: 'transparent', color: '#2196f3' }} aria-describedby={id_black_out_helper} onClick={handleClickBlackoutHelper}><HelpOutlineIcon sx={{ cursor: 'pointer' }} /></button></Tooltip>
                <Popover
                    id={id_black_out_helper}
                    open={open_black_out_helper}
                    anchorEl={black_out_helper_anchorEl}
                    onClose={handleCloseBlackoutHelper}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                >
                    <Alert className={'ft-justify ft-lineBreak'} sx={{ height: '100%' }} severity={'info'}>
                        <AlertTitle>{t('shared.info')} :</AlertTitle>
                        {t('shared.stock-edit-black-out-helper')}
                    </Alert>
                </Popover>
            </div>
            {/* <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <FormControl >
                    <FormControlLabel control={<Checkbox checked={stocks_edit_mode === 'STOCK'} onChange={onUpdateEditMode('STOCK')} color={'primary'} />} label={t('shared.activate-edit-stock')} />
                </FormControl>
                <Tooltip title={t('shared.info')} ><button style={{ border: 'none', backgroundColor: 'transparent', color: '#2196f3' }} aria-describedby={id_black_out_helper} onClick={handleClickStockHelper}><HelpOutlineIcon sx={{ cursor: 'pointer' }} /></button></Tooltip>
                <Popover
                    id={id_stock_helper}
                    open={open_stock_helper}
                    anchorEl={stock_helper_anchorEl}
                    onClose={handleCloseStockHelper}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                >
                    <Alert className={'ft-justify ft-lineBreak'} sx={{ height: '100%' }} severity={'info'}>
                        <AlertTitle>{t('shared.info')} :</AlertTitle>
                        {t('shared.stock-edit-stock-helper')}
                    </Alert>
                </Popover>
            </div> */}
        </div>
    );
};

export default ChannelManagerStockEditOptions;